module.exports = __webpack_public_path__ + "static/media/room-2.5a2ab370.jpeg";